import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect } from "react-redux";
import { Popup } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { IDWarehouseLookupLayout, IDWorkerLookupLayout } from '../../../../../common/lookups/Layouts/IdLayouts';
import { IMLocationLookupLayout } from '../../../../../common/lookups/Layouts/ImLayouts';
import { WM } from '../../../../../const/constants';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import { alert } from 'devextreme/ui/dialog';
import { ERROR_SEVERITY, formatErrorList } from '../../../../../common/apiErrors';
import { CONCURRENCY_HANDLED, getApiErrorMessage } from '../../../../../common/concurrency';

const runtimeParameter = JSON.stringify([
    { R_STAGINGWAREHOUSE: 'RWarehouse' }
]);
const locationLookupLayout = IMLocationLookupLayout({ moduleType: WM, runtimeParameter });
const IM = "IM";

const StagingAssignmentsLayout = [
    {
        groupId: 1,
        label: "",
        fields: [
            {
                name: "R_STAGINGWAREHOUSE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Staging WH",
                type: "lookup",
                layout: IDWarehouseLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "PLANNEDRECEIVEDSHIPPEDDATETIME",
                tableName: "WMTRANSACTIONHEADER",
                label: "Staging Planned",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            }, {
                name: "STAGINGSTARTDATE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Staging Start",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "R_UNLOADPICKBY",
                tableName: "WMTRANSACTIONHEADER",
                label: "Unload By Worker",
                type: "lookup",
                layout: IDWorkerLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "R_CHECKBY",
                tableName: "WMTRANSACTIONHEADER",
                label: "Check By Worker",
                type: "lookup",
                layout: IDWorkerLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "R_PUTAWAYBY",
                tableName: "WMTRANSACTIONHEADER",
                label: "Put Away By Worker",
                type: "lookup",
                layout: IDWorkerLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "R_LOADBY",
                tableName: "WMTRANSACTIONHEADER",
                label: "Load By Worker",
                type: "lookup",
                layout: IDWorkerLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "R_PICKBY",
                tableName: "WMTRANSACTIONHEADER",
                label: "Pick By Worker",
                type: "lookup",
                layout: IDWorkerLookupLayout,
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "COMMENTFLAG",
                tableName: "WMTRANSACTIONHEADER",
                label: "Comment Flag",
                type: "select",
                options: [""],
                required: false,
                visible: true,
                searchEnabled: false,
                isLabelChanged: false,
            }
        ]
    },
    {
        groupId: 2,
        label: "",
        fields: [
             
            {
                name: "R_STAGINGAREA",
                tableName: "WMTRANSACTIONHEADER",
                label: "Staging Area",
                type: "lookup",
                layout: IMLocationLookupLayout({ moduleType: IM, runtimeParameter }),
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "STAGINGINFO",
                tableName: "WMTRANSACTIONHEADER",
                label: "",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
                readOnly: true,
            },  {
                name: "STAGINGENDDATE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Staging Finish",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "UNLOADPICKBYPLANDATE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Plan Date Time",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "CHECKBYPLANDATE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Check Plan Date Time",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "PUTAWAYBYPLANDATE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Put Away Plan Date Time",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "LOADBYPLANDATE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Load By Plan Date Time",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "PICKBYPLANDATE",
                tableName: "WMTRANSACTIONHEADER",
                label: "Pick By Plan Date Time",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            }, {
                name: "COMMENT_DISPLAY",
                tableName: "WMTRANSACTIONHEADER",
                label: "Comment",
                type: "textarea",
                required: false,
                visible: true,
                isLabelChanged: false,
            }
        ]
    },
    {
        groupId: 3,
        label: "",
        fields: [

            {
                name: "STAGINGINFO",
                tableName: "WMTRANSACTIONHEADER",
                label: "",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
                readOnly: true,
            },
            {
                name: "STAGINGINFO",
                tableName: "WMTRANSACTIONHEADER",
                label: "",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
                readOnly: true,
            }, {
                name: "ACTUALRECEIVEDSHIPPEDDATETIME",
                tableName: "WMTRANSACTIONHEADER",
                label: "Staging Recv/Ship Dt",
                type: "datetime",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "UNLOADPICKBYHOURS_H",
                tableName: "WMTRANSACTIONHEADER",
                label: "Unload By Hours",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "CHECKBYHOURS_H",
                tableName: "WMTRANSACTIONHEADER",
                label: "Check By Hours",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "PUTAWAYBYHOURS_H",
                tableName: "WMTRANSACTIONHEADER",
                label: "Put Away By Hours",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "LOADBYHOURS_H",
                tableName: "WMTRANSACTIONHEADER",
                label: "Load By Hours",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },{
                name: "PICKBYHOURS_H",
                tableName: "WMTRANSACTIONHEADER",
                label: "Pick By Hours",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
        ]
    },
    {
        groupId: 4,
        label: "",
        fields: [

            {
                name: "STAGINGINFO",
                tableName: "WMTRANSACTIONHEADER",
                label: "",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
                readOnly: true,
            },{
                name: "STAGINGINFO",
                tableName: "WMTRANSACTIONHEADER",
                label: "",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
                readOnly: true,
            },{
                name: "STAGINGINFO",
                tableName: "WMTRANSACTIONHEADER",
                label: "",
                type: "text",
                required: false,
                visible: true,
                isLabelChanged: false,
                readOnly: true,
            },
            {
                name: "UNLOADPICKBYHOURS_M",
                tableName: "WMTRANSACTIONHEADER",
                label: "Unload By Minutes",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "CHECKBYHOURS_M",
                tableName: "WMTRANSACTIONHEADER",
                label: "Check By Minutes",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "PUTAWAYBYHOURS_M",
                tableName: "WMTRANSACTIONHEADER",
                label: "Put Away By Minutes",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "LOADBYHOURS_M",
                tableName: "WMTRANSACTIONHEADER",
                label: "Load By Minutes",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },
            {
                name: "PICKBYHOURS_M",
                tableName: "WMTRANSACTIONHEADER",
                label: "Pick By Minutes",
                type: "number",
                required: false,
                visible: true,
                isLabelChanged: false,
            },

        ]
    },
    

];

const commentFlagOptions = [
    { Rowid: "T", Code: "Transaction Comment" },
    { Rowid: "P", Code: "Plan Comment" }
];

const parseHoursDateTime = (val) => {
    if (!val) return { h: null, m: null };
    const s = typeof val === 'string' ? val : new Date(val).toISOString();
    const match = s.match(/T(\d{2}):(\d{2})/);
    if (match) return { h: parseInt(match[1], 10), m: parseInt(match[2], 10) };
    return { h: null, m: null };
};

const buildHoursDateTime = (h, m) => {
    if ((h == null || h === '') && (m == null || m === '')) return null;
    const hh = String(((Number(h) || 0) % 24)).padStart(2, '0');
    const mm = String(Number(m) || 0).padStart(2, '0');
    return `1899-12-31T${hh}:${mm}:00`;
};

const StagingAssignments = ({ visible, onClose, transactionRowId, accessToken, transactionNumber, oidc }) => {
    const [loading, setLoading] = useState(false);
    const [formFields, setFormFields] = useState({});
    const [transactionData, setTransactionData] = useState(null);
    const formRefs = useRef({});
    const currentUser = oidc?.user;
    const DYNAMICFORMSETTING = oidc?.user?.profile?.DYNAMICFORMSETTING;

    useEffect(() => {
        if (visible && transactionRowId) {
            loadTransaction();
        }
        if (!visible) {
            setFormFields({});
            setTransactionData(null);
        }
    }, [visible, transactionRowId]);

    const loadTransaction = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${window._env_.REACT_APP_APIS}/wm/Transaction/GetTransactionByRowId?rowid=${transactionRowId}`,
                {
                    headers: {
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            const data = response.data;
            setTransactionData(data);
            setFormFields({
                R_STAGINGWAREHOUSE: data?.R_STAGINGWAREHOUSE || null,
                R_STAGINGAREA: data?.R_STAGINGAREA || null,
                STAGINGINFO: '',
                PLANNEDRECEIVEDSHIPPEDDATETIME: data?.PLANNEDRECEIVEDSHIPPEDDATETIME || null,
                STAGINGSTARTDATE: data?.STAGINGSTARTDATE || null,
                STAGINGENDDATE: data?.STAGINGENDDATE || null,
                ACTUALRECEIVEDSHIPPEDDATETIME: data?.ACTUALRECEIVEDSHIPPEDDATETIME || null,
                R_UNLOADPICKBY: data?.R_UNLOADPICKBY || null,
                UNLOADPICKBYPLANDATE: data?.UNLOADPICKBYPLANDATE || null,
                UNLOADPICKBYHOURS_H: parseHoursDateTime(data?.UNLOADPICKBYHOURS).h,
                UNLOADPICKBYHOURS_M: parseHoursDateTime(data?.UNLOADPICKBYHOURS).m,
                R_CHECKBY: data?.R_CHECKBY || null,
                CHECKBYPLANDATE: data?.CHECKBYPLANDATE || null,
                CHECKBYHOURS_H: parseHoursDateTime(data?.CHECKBYHOURS).h,
                CHECKBYHOURS_M: parseHoursDateTime(data?.CHECKBYHOURS).m,
                R_PUTAWAYBY: data?.R_PUTAWAYBY || null,
                PUTAWAYBYPLANDATE: data?.PUTAWAYBYPLANDATE || null,
                PUTAWAYBYHOURS_H: parseHoursDateTime(data?.PUTAWAYBYHOURS).h,
                PUTAWAYBYHOURS_M: parseHoursDateTime(data?.PUTAWAYBYHOURS).m,
                R_LOADBY: data?.R_LOADBY || null,
                LOADBYPLANDATE: data?.LOADBYPLANDATE || null,
                LOADBYHOURS_H: parseHoursDateTime(data?.LOADBYHOURS).h,
                LOADBYHOURS_M: parseHoursDateTime(data?.LOADBYHOURS).m,
                R_PICKBY: data?.R_PICKBY || null,
                PICKBYPLANDATE: data?.PICKBYPLANDATE || null,
                PICKBYHOURS_H: parseHoursDateTime(data?.PICKBYHOURS).h,
                PICKBYHOURS_M: parseHoursDateTime(data?.PICKBYHOURS).m,
                COMMENT: data?.COMMENT || '',
                PLANCOMMENT: data?.PLANCOMMENT || '',
                COMMENTFLAG: 'T',
                COMMENT_DISPLAY: data?.COMMENT || ''
            });
        } catch (error) {
            console.error('Error loading transaction:', error);
            alert("Error loading transaction.", "Error");
        } finally {
            setLoading(false);
        }
    };

    const handleFieldChange = useCallback((name, value) => {
        if (name === 'COMMENTFLAG') {
            setFormFields(prev => {
                const display = value === 'P' ? (prev.PLANCOMMENT || '') : (prev.COMMENT || '');
                if (formRefs.current['COMMENT_DISPLAY']) {
                    formRefs.current['COMMENT_DISPLAY'].instance().option('value', display);
                }
                return { ...prev, COMMENTFLAG: value, COMMENT_DISPLAY: display };
            });
            return;
        }
        if (name === 'COMMENT_DISPLAY') {
            setFormFields(prev => {
                if (prev.COMMENTFLAG === 'P') {
                    return { ...prev, COMMENT_DISPLAY: value, PLANCOMMENT: value };
                }
                return { ...prev, COMMENT_DISPLAY: value, COMMENT: value };
            });
            return;
        }
        if (name === 'R_STAGINGWAREHOUSE') {
            if (formRefs.current['R_STAGINGAREA']) {
                formRefs.current['R_STAGINGAREA'].instance().option('value', null);
            }
            if (value) {
                var areaDataSource = new DataSource({
                    store: new createStore({
                        key: 'id',
                        loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                        loadParams: {
                            locationTypes: 'L',
                            warehouseRowId: value
                        },
                        onBeforeSend: function (method, ajaxOptions) {
                            ajaxOptions.headers = {
                                Authorization: `Bearer ${accessToken}`
                            };
                        }
                    }),
                    paginate: true,
                    pageSize: 100
                });
                if (formRefs.current['R_STAGINGAREA']) {
                    formRefs.current['R_STAGINGAREA'].instance().option('dataSource', areaDataSource);
                }
            }
        }
    }, [accessToken]);

    const handleFormLoad = useCallback(() => {
        if (formRefs.current['COMMENTFLAG']) {
            const newOptions = commentFlagOptions.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            formRefs.current['COMMENTFLAG'].instance().option('dataSource', newOptions);
            formRefs.current['COMMENTFLAG'].instance().option('valueExpr', 'id');
            formRefs.current['COMMENTFLAG'].instance().option('displayExpr', 'name');
        }
    }, []);

    const handleSave = async () => {
        if (!transactionData) return;
        setLoading(true);
        try {
            const { Profile, Carrier, isLineItemExist, UserValidationMessage, ItemTotalQuanity, ItemTotalChargeAmount, TotalChargesCount, CustomerAddress, CustomerCreditLimit, CustomerCreditBalance, CustomerCreditRemaning, ...cleanData } = transactionData;
            const updatedData = { ...cleanData, R_STAGINGWAREHOUSE: formFields.R_STAGINGWAREHOUSE, R_STAGINGAREA: formFields.R_STAGINGAREA, PLANNEDRECEIVEDSHIPPEDDATETIME: formFields.PLANNEDRECEIVEDSHIPPEDDATETIME, STAGINGSTARTDATE: formFields.STAGINGSTARTDATE, STAGINGENDDATE: formFields.STAGINGENDDATE, ACTUALRECEIVEDSHIPPEDDATETIME: formFields.ACTUALRECEIVEDSHIPPEDDATETIME, R_UNLOADPICKBY: formFields.R_UNLOADPICKBY, UNLOADPICKBYPLANDATE: formFields.UNLOADPICKBYPLANDATE, UNLOADPICKBYHOURS: buildHoursDateTime(formFields.UNLOADPICKBYHOURS_H, formFields.UNLOADPICKBYHOURS_M), R_CHECKBY: formFields.R_CHECKBY, CHECKBYPLANDATE: formFields.CHECKBYPLANDATE, CHECKBYHOURS: buildHoursDateTime(formFields.CHECKBYHOURS_H, formFields.CHECKBYHOURS_M), R_PUTAWAYBY: formFields.R_PUTAWAYBY, PUTAWAYBYPLANDATE: formFields.PUTAWAYBYPLANDATE, PUTAWAYBYHOURS: buildHoursDateTime(formFields.PUTAWAYBYHOURS_H, formFields.PUTAWAYBYHOURS_M), R_LOADBY: formFields.R_LOADBY, LOADBYPLANDATE: formFields.LOADBYPLANDATE, LOADBYHOURS: buildHoursDateTime(formFields.LOADBYHOURS_H, formFields.LOADBYHOURS_M), R_PICKBY: formFields.R_PICKBY, PICKBYPLANDATE: formFields.PICKBYPLANDATE, PICKBYHOURS: buildHoursDateTime(formFields.PICKBYHOURS_H, formFields.PICKBYHOURS_M), COMMENT: formFields.COMMENT, PLANCOMMENT: formFields.PLANCOMMENT };
            const res = await axios.put(
                `${window._env_.REACT_APP_APIS}/wm/Transaction/PutTransaction`,
                updatedData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            // Reaching here means the save happened — a profile-rule refusal is now a real 400 and lands in
            // the catch below. See Transportation.js for the full note.
            notify("Staging/Assignments saved successfully.", "success", 3000);
            onClose();
        } catch (error) {
            console.error('Error saving:', error);
            if (error?.[CONCURRENCY_HANDLED]) {
                return;
            }
            alert(formatErrorList(error?.response?.data?.errors, ERROR_SEVERITY.ERROR)
                || getApiErrorMessage(error, "Error saving staging/assignments."), "Error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Popup
            visible={visible}
            onHiding={onClose}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            title={`WM Staging/Assignments Entry (${transactionNumber || ''})`}
            width={1050}
            height={635}
        >
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={loading}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />

            <style>{`.staging-assignments-form .flex-container { display: block !important; }`}</style>
            <div className="staging-assignments-form">
                <FormField
                    currrentUser={currentUser}
                    layoutId='2E5DE8E3-BC98-44E8-959D-95024AA2EA76'
                    layoutName='StagingAssignmentsForm'
                    defaultFormSchema={StagingAssignmentsLayout}
                    formFields={formFields}
                    setformFields={setFormFields}
                    handleFieldValueChange={handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleFormLoad}
                />
                <div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', padding: '10px', borderTop: '1px solid #eee' }}>
                        <Button text="Save" type="default"   onClick={handleSave} />
                        <Button text="Cancel" type="normal" icon="close" onClick={onClose} />
                    </div>
                </div>
            </div>
        </Popup>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(StagingAssignments);
